import { useEffect, useState } from 'react';
import { supabase, getSafeSession } from '@/lib/supabaseClient';
import type { Profile } from '@/lib/supabaseClient';

export function useProfile() {
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    getSafeSession().then((session) => {
      const userId = session?.user?.id;
      if (!userId) {
        if (mounted) setLoading(false);
        return;
      }
      supabase
        .from('profiles')
        .select('*')
        .eq('id', userId)
        .maybeSingle()
        .then(({ data: p, error }) => {
          if (!mounted) return;
          if (error) {
            console.error(error);
          }
          setProfile(p as Profile | null);
          setLoading(false);
        });
    });

    return () => {
      mounted = false;
    };
  }, []);

  return { profile, loading };
}